import { useState, useRef, useEffect, FC } from 'react';
import { Flex } from '@chakra-ui/react';
import DropElement from './DropElement';
import { isEmpty } from '../../helpers';
import { isEqual } from 'lodash';

const DragDropList = <T,>({
  listItem,
  List,
  type,
  noDragIndexes,
  noDropIndexes,
  noDrag,
  containerStyle,
  containerId,
  onDrag,
  onDrop,
  onMove: onMoveCustom,
}: {
  listItem: T[];
  List: FC<{ item: T; idx: number }>;
  type: string;
  noDragIndexes?: number[];
  noDropIndexes?: number[];
  noDrag?: boolean;
  containerStyle?: Record<string, any>;
  containerId?: number;
  onDrag?: (index: number) => void;
  onDrop: (list: T[]) => void;
  onMove?: (dragIndex: number, dropIndex: number) => T[] | void;
}) => {
  const [orderedList, setOrderedList] = useState(listItem);
  const currIndex = useRef<any>();

  const tempList = useRef<T[]>([]);

  useEffect(() => {
    setOrderedList(listItem);
  }, [listItem]);

  const onMove = (dragIndex: number, dropIndex: number) => {
    currIndex.current = dragIndex;

    if (isEmpty(dropIndex) || isEmpty(dragIndex)) return;

    const [dragId] = `${dragIndex}`.split('.');
    const [dropId] = `${dropIndex}`.split('.');

    if (onMoveCustom) {
      onMoveCustom(dragIndex, dropIndex);
    } else {
      const currList = [...tempList.current];
      const [item] = currList.splice(Number(dragId), 1);
      currList.splice(Number(dropId), 0, item);

      setOrderedList(currList);
    }
  };

  const onCancel = () => {
    if (!isEqual(tempList.current, orderedList)) {
      // @TODO cancel action
    }
  };

  const onDragDefault = () => {
    tempList.current = orderedList;
    onDrag?.(currIndex.current);
  };

  const onDropDefault = () => {
    currIndex.current = undefined;
    if (!isEqual(tempList.current, orderedList)) {
      onDrop(orderedList);
    }
  };

  return (
    <Flex flexDirection='column' w='100%' {...containerStyle}>
      {orderedList?.map((item, idx) => (
        <DropElement
          noDrag={noDragIndexes?.includes(idx) || noDrag}
          noDrop={noDropIndexes?.includes(idx)}
          id={`${idx}${!isEmpty(containerId) ? `.${containerId}` : ''}`}
          type={type}
          onMove={onMove}
          onDrag={onDragDefault}
          onDrop={onDropDefault}
          onCancel={onCancel}
          hasStyle={!!containerStyle}
        >
          <List item={item} idx={idx} />
        </DropElement>
      ))}
    </Flex>
  );
};

export default DragDropList;
